import React from 'react';
import './style.css';

const Footer = ({ 
  telefone = "(21) 2666-5800",
  cnpj = "01.475.178/0001-51",
  ano = new Date().getFullYear(),
  razaoSocial = "SegMedic Centro Médico LTDA",
  linksFaq = "https://segmedic.com.br",
  linksCentralAjuda = "https://segmedic.com.br/ajuda"
}) => {
  return (
    <div className="help_home_clean">
      <p className="help_main_text">
        Dúvidas, solicitações ou insatisfações? Fale conosco ligando para{' '}
        <strong>
          <a href={`tel:${telefone.replace(/\D/g, '')}`}>{telefone}</a>
        </strong>.
      </p>
      
      <div className="help_links">
        <a href={linksFaq}>Perguntas Frequentes</a>
        <a href={linksCentralAjuda}>Central de Ajuda</a>
      </div>
      
      <p className="help_footer_cnpj">
        © {ano} {razaoSocial}. {cnpj}
      </p>
    </div>
  );
};

export default Footer;